import { Button } from '@mui/material';
import PictureAsPdfIcon from '@mui/icons-material/PictureAsPdf';
import { filterUndefined } from '../../../../utils/FilterUndefinedObject';
import {
  useHandleFileUpload,
} from './FileUploaderHooks';
import './FileUploader.scss';

const defaultProps = {
  buttonLabel: 'Upload',
  uploadServiceFunction: () => null,
  onUploadSuccess: () => null,
  disabled: false,
  buttonClassName: '',
  isMultiple: false,
  fileAccept: '.pdf',
};

const FileUploader = (props) => {
  const {
    uploadServiceFunction,
    buttonLabel,
    id,
    onUploadSuccess,
    disabled,
    buttonClassName,
    isMultiple,
    fileAccept,
  } = { ...defaultProps, ...filterUndefined(props) };
  const {
    handleOnFileSelect,
  } = useHandleFileUpload({
    uploadServiceFunction,
    onUploadSuccess,
    isMultiple,
  });

  return (
    <>
      <input
        accept={fileAccept}
        className='files-upload-action-input'
        id={id}
        type='file'
        onChange={handleOnFileSelect}
        value=''
        disabled={disabled}
        multiple={`${isMultiple ? 'multiple' : undefined}`}

      />
      <label htmlFor={id}>
        <Button
          variant='contained'
          className={`${buttonClassName || 'btn-green-background'}`}
          startIcon={<PictureAsPdfIcon />}
          component='span'
          disabled={disabled}
          data-test='file-upload'
          onKeyDown={(e) => {
            if (e.key === 'Enter') {
              document.getElementById(id).click();
            }
          }}
        >
          {buttonLabel}
        </Button>
      </label>
    </>
  );
};

export default FileUploader;
